import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-da1c4cd4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "questions-container" }
const _hoisted_2 = { class: "question-primary-language" }
const _hoisted_3 = {
  key: 0,
  class: "question-secondary-language"
}
const _hoisted_4 = { class: "references-container" }
const _hoisted_5 = { class: "reference-primary-language" }
const _hoisted_6 = {
  key: 0,
  class: "reference-secondary-language"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["form-item-container", { 'first-form-item': $props.form_item_order === 0 && $props.layout_mode === 'all_on_one_page' }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString($props.question_lang1), 1),
      ($props.bilingue)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString($props.question_lang2), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.options, (option, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "reference"
        }, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(option.text_lang1), 1),
          ($props.bilingue)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(option.text_lang2), 1))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ])
  ], 2))
}